<template>
  <div v-if="showModal" class="modal false z-50 fixed w-full h-full top-0 left-0 flex items-center justify-center">
    <div class="absolute w-full h-full bg-gray-900 opacity-50 modal-overlay" @click="showModal = false"></div>
    <div class="z-50 w-11/12 mx-auto overflow-y-auto bg-white rounded shadow-lg modal-container md:max-w-5xl">
      <div class="px-6 py-4 text-left modal-content flex flex-col">
        <div class="flex items-center justify-between pb-3">
          <p class="text-2xl font-bold">{{ $lang.app.PERSONAL_DATA_PERMISSION_FORM }}</p>
          <div class="z-50 cursor-pointer modal-close" @click="showModal = false">
            <XIcon class="w-5 h-5 text-black"/>
          </div>
        </div>
        <div class="mb-4 flex-auto">
          <div class="mb-8 h-full">
            <embed class="w-full h-full" src="/Personal_data_permission_form.pdf">
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      showModal: false,
    }
  },
  beforeMount() {
    this.$emitter.on('open-personal-data-agreement-modal', () => {
      this.showModal = true
    })
  },
  beforeUnmount() {
    this.$emitter.off('open-personal-data-agreement-modal')
  }
}
</script>
<style scoped>
.modal-content {
  height: 90vh;
}
</style>